import Updated from './2024';

export default Updated;
